<template>
    <dl class="description-list-wrapper">
        <DescriptionItem :label="$t('문자열 키')">
            {{ detailData.key || '-' }}
        </DescriptionItem>
        <DescriptionItem :label="$t('한국어')">
            {{ detailData.ko || '-' }}
        </DescriptionItem>
        <DescriptionItem :label="$t('영어')">
            {{ detailData.en || '-' }}
        </DescriptionItem>
        <DescriptionItem :label="$t('중국어')">
            {{ detailData.ca || '-' }}
        </DescriptionItem>
        <div class="row-wrapper">
            <DescriptionItem :label="$t('등록일시')">
                {{ get_date(detailData.created_at) || '-' }}
            </DescriptionItem>

            <DescriptionItem :label="$t('수정일시')">
                {{ get_date(detailData.updated_at) || '-' }}
            </DescriptionItem>
        </div>
    </dl>
</template>

<script>
import DescriptionItem from '@shared/components/common/DescriptionItem.vue';
import {operatorOptions} from '@shared/components/admin/pages/Management/CampaignConnectRule/Condition/data';
import {getDate} from '@shared/components/admin/pages/Management/common-data';

export default {
    name: 'LocaleStringDetail',
    components: {
        DescriptionItem
    },
    props: {
        detailData: {
            type: Object,
            required: true,
            default: () => ({id: null}),
        }
    },
    computed: {
        get_date() {
            return (date) => {
                return getDate(date);
            };
        }
    }
};
</script>
<style lang="scss" scoped>

</style>
